import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { authService } from 'services';
import { renderToastMessageApi } from 'utils/toastMessage';

import { ServiceError } from '../../errors/serviceError';
import { IApiErrorMeta } from '../../types/interfaces/api';

class ApiError<T> extends ServiceError<IApiErrorMeta> {
  public readonly status: number;

  public readonly data: T;

  constructor(request: AxiosRequestConfig, axiosResponse: AxiosResponse, err: any, hideToastMessage = false) {
    const response = !axiosResponse
      ? { status: -1, data: '' }
      : { status: axiosResponse.status, data: axiosResponse.data };

    const code = response?.data?.code || response?.data?.statusCode;

    const message =
      response.status === -1
        ? 'Erro ao acessar servidores, verifique sua conexão com a internet e tente novamente'
        : code
        ? response.data.message
        : 'Erro ao processar sua requisição. Tente novamente mais tarde.';

    super(
      message,
      {
        request: {
          baseURL: request.baseURL,
          url: request.url,
          method: request.method,
          params: request.params,
          data: request.data,
          headers: request.headers
        },
        response,
        err
      },
      false
    );

    this.status = response.status;
    this.data = response.data;

    if (!hideToastMessage) {
      renderToastMessageApi(this.status, message);
    }

    if (code === 403 && message === 'Usuário não possui mais permissão de acesso') {
      authService.logout();
    }
  }
}

export default ApiError;
